<template>
  <li class="dropdown-language">
    <div class="dropdown">
      <a
        class="dropdown-toggle"
        href="#"
        role="button"
        id="dropdown-language"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <span class="label label-default">
          <span :class="'flag-icon flag-icon-' + banderaActual"></span>
          {{ $t(idiomaActual) }}
        </span>
      </a>
      <div class="dropdown-menu ld" aria-labelledby="dropdown-language">
        <a
          v-for="(idioma, index) in arrayIdiomas"
          v-bind:key="index"
          href="#"
          v-on:click.prevent="cambiarIdioma(idioma)"
        >
          <span class="label label-default texto">
            <span :class="'flag-icon flag-icon-' + idioma.flag"></span>
            {{ $t(idioma.idioma) }}
          </span>
        </a>
      </div>
    </div>
  </li>
</template>


<script>
export default {
  data() {
    return {
      arrayIdiomas: [
        { flag: "es", idioma: "espanol", lang: "es" },
        { flag: "gb", idioma: "ingles", lang: "en" },
        { flag: "fr", idioma: "frances", lang: "fr" }
      ],
      idiomaActual: "espanol",
      banderaActual: "es"
    };
  },

  methods: {
    cambiarIdioma(objLng) {
      this.$i18n.locale = objLng.lang;
      this.idiomaActual = objLng.idioma;
      this.banderaActual = objLng.flag;      
    }
  }
};
</script>
<style scoped>
.ld {
  margin-top: 24px;
  position: fixed !important;
  left: inherit !important;
}

.texto {
  color: #7e7e7e !important;
}
.texto:hover {
  color: #ed8e7d !important;
}
</style>

